//natives
import React from 'react';
import {CircularProgress, TextField, Paper} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';

//components
import Filter from "../../../../../../../../../util/filter/.mixins/Filter";
import Table from "../../../../../../../../../util/Table/.mixins/Table";
import Error from "../../../../../../../../../util/error/.mixins/Error";

//css
import ProtocolosListaCss from './styles';
const useStyles = ProtocolosListaCss();

export default function ProtocolosLista(props) {
    const classes = useStyles();
    
    return (
        <div className="container">

            <Filter {...props}/>
            <br/>

            {!props.state.isError &&
                <>
                    {((props.state.listaDatas.length > 0) || (props.state.isLoadingDatas)) && !props.state.isLoading &&
                        <Paper align="center">

                            {props.state.isLoadingDatas &&
                                <>
                                    <CircularProgress
                                        size={24} 
                                        style={{margin: 15}} 
                                    />
                                </>
                            }

                            {!props.state.isLoadingDatas && 
                                <>
                                    <Autocomplete
                                        id="dt_protocolo"
                                        style={{ width: 200 }}
                                        options={props.state.listaDatas}
                                        getOptionLabel={option => option.dt}
                                        onChange={(e,v)=>{props.handleChange(v)}}
                                        loadingText={"Carregando..."}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                variant="standard"
                                                label={(props.state.dataAgenda==null)?"Escolha uma data":props.state.dataAgenda}
                                                placeholder="01/12/2019"
                                                fullWidth
                                            />
                                        )}
                                    />
                                    <br/>
                                </>
                            }

                        </Paper>
                    }
                    <br/>
                </>
            }

            {props.state.isLoading &&
                <div align="center">
                    <CircularProgress />
                </div>
            }
            
            {!props.state.isLoading &&
                <Table {...props} className={classes.root}/>
            }

            {props.state.isError &&
                <div align="center">
                    <Error text={props.state.error}/>
                </div>
            }

        </div>
    );
}